module.exports = __webpack_public_path__ + "img/step9-b.882387ce.png";